/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Scoring_RulesInputs */

const en_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoring rules`)
};

const ar_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قواعد التقييم`)
};

const bn_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোরিং নিয়ম`)
};

const de_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertungsregeln`)
};

const es_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reglas de puntuación`)
};

const fr_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règles de notation`)
};

const pt_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regras de pontuação`)
};

const zh_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分规则`)
};

const tr_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puanlama kuralları`)
};

const ru_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правила оценки`)
};

const pl_svchip_scoring_rules = /** @type {(inputs: Svchip_Scoring_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reguły punktacji`)
};

/**
* | output |
* | --- |
* | "Scoring rules" |
*
* @param {Svchip_Scoring_RulesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_scoring_rules = /** @type {((inputs?: Svchip_Scoring_RulesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Scoring_RulesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_scoring_rules(inputs)
	if (locale === "bn") return bn_svchip_scoring_rules(inputs)
	if (locale === "de") return de_svchip_scoring_rules(inputs)
	if (locale === "es") return es_svchip_scoring_rules(inputs)
	if (locale === "fr") return fr_svchip_scoring_rules(inputs)
	if (locale === "pt") return pt_svchip_scoring_rules(inputs)
	if (locale === "zh") return zh_svchip_scoring_rules(inputs)
	if (locale === "tr") return tr_svchip_scoring_rules(inputs)
	if (locale === "ru") return ru_svchip_scoring_rules(inputs)
	if (locale === "pl") return pl_svchip_scoring_rules(inputs)
	return en_svchip_scoring_rules(inputs)
});